import React, { Fragment, useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { useAmplitude, useUserInfo } from "../../../hooks";
import { TYPE, URL } from "../../../constant";
import useHackleInfo from "../../../hooks/useHackle";
import HACKLE_DATA from "../../../constant/HACKLE_DATA";
import { appsflyer, appsflyerEventName } from "../../../utils/appsflyer";

const PayPopup2 = ({ onClose }) => {
  const { info } = useUserInfo();
  const [isShowPopup, setIsShowPopup] = useState(false);

  const history = useHistory();
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const { setHackleLog } = useHackleInfo();
  const { setAmplitudeLog } = useAmplitude();

  const handlePage = useCallback(() => {
    // 결제팝업버튼 클릭
    setAmplitudeLog({ eventCategory: 'payment', eventName: '결제팝업버튼 클릭' });
    setHackleLog(HACKLE_DATA.TYPE.POP_REPORT_BTN_CLICK);
    appsflyer({
      eventName: appsflyerEventName.purchase_pop_btn_click,
      eventParams: null,
    });

    if(info?.countryCd === TYPE.COUNTRY_CODE.KOREA) {
      // KR
      history.push(URL.PAYMENT.SUBSCRIBE);
    } else {
      // IN or PH
      history.push(URL.PAYMENT.SUBSCRIBE_NEW);
    }
    
  }, [info]);

  const handleCloseBtn = useCallback(() => {
    setIsShowPopup(false);
    onClose();
  }, []);

  useEffect(() => {
    setIsShowPopup(true);
  }, [info]);

  return (
    // 학습노트 팝업
    isShowPopup ? (
      <div className="pay_popup bePus">
        <div className="lp-wrap lp-middle">
          <div className="lc-alert lc-def">
            <img
              className="logo_mathpid"
              src={`${process.env.PUBLIC_URL}/static/images/payment/logo_mathpid.svg`}
              alt="mathpid premium"
            />
            <button
              type="button"
              id="close"
              className="btn close"
              onClick={handleCloseBtn}
            >
              <span className="blind">{t("PAYMENT.PAY_POPUP_2.msg001")}</span>
            </button>
            <p
              className="sub_txt"
              dangerouslySetInnerHTML={{
                __html: t("PAYMENT.PAY_POPUP_2.msg002"),
              }}
            />
            <img
              src={`${process.env.PUBLIC_URL}/static/images/payment/intro_img_${language}.png`}
              alt=""
            />
            <div className="lp-btnBox">
              <button
                type="button"
                className="btn btn-blue"
                onClick={handlePage}
              >
                {t("PAYMENT.PAY_POPUP_2.msg003")}
              </button>
            </div>
            {/* <div className="pay_sum">
              {info?.countryCd === TYPE.COUNTRY_CODE.KOREA && (
                <Fragment>
                  <span className="sum">
                    {t(
                      `PAYMENT.PAY_POPUP_2.msg004_${
                        info?.storeProductID === TYPE.PAYMENT["KR"].PRODUCT_ID
                          ? "KR"
                          : "IN"
                      }`
                    )}
                  </span>
                  <span className="year">
                    {t(
                      `PAYMENT.PAY_POPUP_2.msg005_${
                        info?.storeProductID === TYPE.PAYMENT["KR"].PRODUCT_ID
                          ? "KR"
                          : "IN"
                      }`
                    )}
                  </span>
                </Fragment>
              )} */}
              {/* {info?.countryCd === TYPE.COUNTRY_CODE.INDIA && (
                <Fragment>
                  <span className="sum">₹1550</span>
                  <span className="year"> ₹309.99 / per Year</span>
                </Fragment>
              )}
              {info?.countryCd === TYPE.COUNTRY_CODE.PHILIPPINES && (
                <Fragment>
                  <span className="sum">₱1050</span>
                  <span className="year"> ₱209.99 / per Year</span>
                </Fragment>
              )} */}
            {/* </div> */}
          </div>
        </div>
      </div>
    ) : (
      <></>
    )
  );
};

export default PayPopup2;

PayPopup2.defaultProps = {
  onClose: () => {},
};